"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const media_service_g_1 = require("./media-service.g");
class MediaService extends media_service_g_1.MediaService {
    /**
    * Retrieves prompt media.
    * @summary Get prompt media
    * @param {string} promptId ID of the prompt
    * @throws {RequiredError}
    */
    getPromptBinary(params) {
        // verify required parameter 'promptId' is not null or undefined
        if (params.promptId === null || params.promptId === undefined) {
            throw new utils_1.RequiredError('promptId', 'Required parameter promptId was null or undefined when calling getPrompt.');
        }
        const path = `/prompts/{promptId}`
            .replace(`{${'promptId'}}`, String(params.promptId));
        const headers = {};
        const query = {};
        let body = null;
        return this.serviceRequester.request({ method: 'GET', path, query, headers, body, options: params.options })
            .then(response => {
            return {
                type: response.headers['content-type'],
                stream: response.body,
            };
        });
    }
    /**
    * Update prompt media.  Returns an error if the prompt meta hasn't been created.
    * @summary Update prompt media
    * @param {string} promptId ID of the prompt
    * @param {any} body Binary data of the prompt
    * @throws {RequiredError}
    */
    updatePromptBinary(params) {
        return this.updatePrompt(params);
    }
}
exports.MediaService = MediaService;
//# sourceMappingURL=media-service.js.map